/**
 * Lucide icon registry — add icons here as they are used in the app.
 * Import from this file, never directly from lucide-angular, to keep
 * the bundle optimised and the list auditable in one place.
 *
 * Icon name reference: https://lucide.dev
 * Angular usage: <lucide-icon name="icon-name" [size]="16" />
 */

import {
  // ─── Navigation & layout ────────────────────────────────────────────────
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  Menu,

  // ─── Sidebar menu ───────────────────────────────────────────────────────
  LayoutGrid, // Dashboard / panel
  Map, // Customer journey
  Zap, // Behavioral pill
  Users, // Customers / clients
  Folder, // Instances
  FileText, // Operations
  CreditCard, // Payments
  Phone, // Outbound calls
  Banknote, // Payment agreements / payment methods
  Network, // Campaigns
  FolderOpen, // Portfolios
  MessageSquare, // Templates / copies
  PieChart, // Segments
  User, // User config
  Box, // Collector profiles
  Tag, // Brands
  Send, // Notification channels
  UserPlus, // Users (admin)
  UserCheck, // User created confirmation
  Percent, // Tax entities
  Briefcase, // Services
  MapPin, // Regional config
  TrendingUp, // Data sharing / event hooks
  Code, // Phases

  // ─── Actions ────────────────────────────────────────────────────────────
  Activity,
  List,
  Hash,
  Plus,
  Minus,
  Maximize2,
  Trash2,
  Pencil,
  Check,
  X,
  Search,
  Filter,
  FilterX,
  Download,
  Upload,
  RefreshCw,
  Copy,
  Link2,
  ExternalLink,
  Wrench,
  DollarSign,
  MoreHorizontal,
  MoreVertical,
  Save,
  Inbox,
  PanelLeftClose,
  Play,
  Pause,
  SkipBack,
  SkipForward,
  LoaderCircle,

  // ─── Status & feedback ──────────────────────────────────────────────────
  Info,
  AlertCircle,
  CircleAlert,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  Timer,

  // ─── Content ────────────────────────────────────────────────────────────
  Server,
  Database,
  Settings,
  SlidersHorizontal,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Bell,
  BellOff,
  Calendar,
  CalendarDays,
  Mail,
  Smartphone,
  Globe,
  Bot,
  MessageSquareDashed,
  Sparkles,
  Wallet,
  CalendarCheck,
  MessageCircle,
  PhoneOutgoing,
  PhoneCall,
  Megaphone,
  Building2,
  RotateCcw,

  KeyRound,
  Webhook,
  Receipt,

  // ─── Credit Wallet ──────────────────────────────────────────────────────────
  Layers,
  CirclePlus,
  ShieldCheck,
} from 'lucide-angular';

export const LUCIDE_ICONS = {
  // Navigation
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  Menu,

  // Sidebar
  LayoutGrid,
  Map,
  Zap,
  Users,
  Folder,
  FileText,
  CreditCard,
  Phone,
  Banknote,
  Network,
  FolderOpen,
  MessageSquare,
  PieChart,
  User,
  Box,
  Tag,
  Send,
  UserPlus,
  UserCheck,
  Percent,
  Briefcase,
  MapPin,
  TrendingUp,
  Code,

  // Actions
  Activity,
  List,
  Hash,
  Plus,
  Minus,
  Maximize2,
  Trash2,
  Pencil,
  Check,
  X,
  Search,
  Filter,
  FilterX,
  Download,
  Upload,
  RefreshCw,
  Copy,
  Link2,
  ExternalLink,
  Wrench,
  DollarSign,
  MoreHorizontal,
  MoreVertical,
  Save,
  Inbox,
  PanelLeftClose,
  Play,
  Pause,
  SkipBack,
  SkipForward,
  LoaderCircle,

  // Status
  Info,
  AlertCircle,
  CircleAlert,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  Timer,

  // Content
  Server, Database, Settings, SlidersHorizontal, Eye, EyeOff, Lock, Unlock,
  Bell, BellOff, Calendar, CalendarDays, Mail, Smartphone, Globe,
  Bot, MessageSquareDashed, Sparkles, Wallet, CalendarCheck, MessageCircle,
  PhoneOutgoing,
  PhoneCall,
  Building2,
  RotateCcw,

  // Configuration
  KeyRound,
  Webhook,

  // Credit Wallet
  Layers,
  CirclePlus,
  ShieldCheck,
  Receipt,
};
